import styledC from 'styled-components';

import { IconButton } from '@adsk/alloy-react-button';
import { MagnifyingGlassIcon } from '@adsk/alloy-react-icon';
import { SearchFieldDesignTokens } from '@adsk/alloy-react-styles';

/**
 * Styled IconButton component for SearchField magnifying glass icon.
 * Supports theme tokens for color customization.
 */

type SearchFieldIconButtonProps = {
  $tokens?: SearchFieldDesignTokens;
};

export const SearchFieldIconButton = styledC(IconButton).attrs({
  renderIcon: MagnifyingGlassIcon.renderIcon,
})<SearchFieldIconButtonProps>`
  color: ${({ $tokens }) => $tokens?.icon?.color};
  ${(props) =>
    !props.disabled && {
      pointerEvents: 'auto',
      cursor: 'pointer',
    }}
`;
